/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import i18n from 'live/services/i18n'

import { FilterContainer } from './style'

interface IOrder {
    field: string
    order: boolean
}

interface IProps {
    filter?: Set<string>
    setFilter?: (k: Set<string>) => void
    list?: Set<string>
    setList?: (k: Set<string>) => void
    search?: string
    setSearch?: (k: string) => void
    field?: string
    order?: IOrder
    setOrder?: (k: IOrder) => void
    onClearAll?: number
}

export const ReportFilterToRequisition: React.FC<IProps> = ({
    field,
    search,
    setSearch,
    order,
    setOrder,
    list,
    filter,
    setFilter,
    onClearAll
}) => {
    const [listing] = useState<string[]>(Array.from(list))
    const [filtering, setFiltering] = useState<string[]>(Array.from(filter))

    const onRemoveFilter = (el: string): void => {
        filter.delete(el)
        setFiltering(Array.from(filter))
    }

    const onAddFilter = (el: string): void => {
        filter.add(el)
        setFiltering(Array.from(filter))
        setSearch('')
    }

    const onClearFilter = (): void => {
        filter.clear()
        setFilter(filter)
        setFiltering(Array.from(filter))
        setSearch('')
    }

    const onOrderList = (): void => {
        if (order.field === field && order.order) {
            setOrder({ field: field, order: false })
        } else if (order.field === field && !order.order) {
            setOrder({ field: field, order: true })
        } else {
            setOrder({ field: field, order: true })
        }
    }

    useEffect(() => {
        setFilter(new Set<string>(filtering))
    }, [listing, filtering])

    useEffect(() => {
        if (filter.size > 0) {
            onClearFilter()
        }
    }, [onClearAll])

    return (
        <FilterContainer>
            <div className="searchFilter">
                <i className="fal fa-search"></i>
                <input
                    type="text"
                    placeholder={i18n('Search')}
                    onChange={e => setSearch(e.target.value)}
                    value={search}
                />
                <button onClick={() => onAddFilter(search)}>
                    <i className="fas fa-plus"></i>
                </button>
                <button onClick={() => onOrderList()}>
                    <i className="far fa-sort-alt"></i>
                </button>
            </div>
            <div className="selection">
                <div className="line">
                    <span>{i18n('Selected filters')}:</span>
                    <button className="btn btn-link" onClick={() => onClearFilter()}>
                        {i18n('Clear  all')}
                    </button>
                </div>
                {Array.from(filter).map((item, index) => {
                    return (
                        <button key={index} className="button" onClick={() => onRemoveFilter(item)}>
                            {i18n(item)} <i className="far fa-times"></i>
                        </button>
                    )
                })}
            </div>
        </FilterContainer>
    )
}
